import { SORTING_DIRECTION } from 'src/constants/main';
import { TBooleanInNumber } from 'src/types/main';

export interface ICustomersProfilesFilters {
  search: string;
  status: TBooleanInNumber | undefined;
  sortField: CUSTOMERS_PROFILES_COLUMN_NAME;
  sortDir: SORTING_DIRECTION;
}

export enum CUSTOMERS_PROFILES_COLUMN_NAME {
  NAME = 'name',
  MOBILE = 'mobile',
  REGISTRATION = 'created_at',
  FIRST_ORDER = 'order_first',
  LAST_ORDER = 'order_last',
  TOTAL_REVENUE = 'order_total_sum',
  TOTAL_ORDERS = 'order_total_count',
  AVG_SPEND_PER_ORDER = 'order_total_avg',
}
